import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import PriceCalculator from './components/PriceCalculator/PriceCalculator';
import Services from './components/Services/Services';
import Pricing from './components/Pricing/Pricing';
import Projects from './components/Projects/Projects';
import Testimonial from './components/Testimonial/Testimonial';
import Blogs from './components/Blogs/Blogs';
import FloatingWhatsApp from './components/FloatingWhatsapp';
import Model from './components/Gallery/Model';
import Bridal from './components/Gallery/Bridal';
import PreWedding from './components/Gallery/PreWedding';
import AboutMain from './components/About/AboutMain';
import Contact from './components/Contact/Contact';
import DisplayImages from './components/Gallery/DisplayImages';
import Baby from './components/Gallery/Baby';
import Couple from './components/Gallery/Couple';
import Haldi from './components/Gallery/Haldi';
import All from './components/Gallery/All';
import Wedding from './components/Gallery/Wedding';


function App() {
  return (
    <Router>
     <Header/>
      <Routes>
      <Route
          path="/"
          element={
            <>
             <Hero/>
             <About/>
             <Services/>
             {/* <Pricing/> */}
             {/* <Projects/> */}
             <Blogs/>

            </>
          }
        />
        <Route path="/about" element={<><AboutMain /></>} />
        <Route path="/calculator" element={<><PriceCalculator /></>} />
        <Route path="/bridal" element={<><Bridal /></>} />
        <Route path="/couple" element={<><Couple /></>} />
        <Route path="/haldi" element={<><Haldi /></>} />
        <Route path="/pre-wedding" element={<><PreWedding /></>} />
        <Route path="/wedding" element={<><Wedding /></>} />
        <Route path="/baby" element={<><Baby /></>} />
        <Route path="/model" element={<><Model /></>} />
        <Route path="/contact" element={<><Contact /></>} />
        {/* <Route path="/images" element={<><DisplayImages /></>} /> */}
        <Route path="/gallery" element={<><All /></>} />
        {/* <Route path="/all" element={<>< /></>} /> */}
        
      </Routes>
     <Footer/>
     <FloatingWhatsApp/>  
    </Router>
  );
}

export default App;
